<div class="row">
    <div class="col-md-12 mb-3">
        <div class="dateBox d-flex justify-content-between">
            <div class="row w-100">
                <div class="col-sm-2" *ngFor="let futDt of suggDates"><strong>{{futDt.SUGG_NUM}} weeks: </strong>{{futDt.SUGG_DATE}}</div>
            </div>
            <!--<p *ngFor="let futDt of suggDates"><strong>{{futDt.SUGG_NUM}} weeks: </strong>{{futDt.SUGG_DATE}}</p>-->
        </div>
    </div>
    <div class="col-md-3 mb-3 d-flex align-items-center flex-column">
        <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text">Dog's Name</span></div>
            <input [(ngModel)]="dogName" type="text" name="dogName" class="form-control">
        </div>
        <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text">Last Name</span></div>
            <input [(ngModel)]="lastName" type="text" name="lastName" class="form-control" placeholder="">
        </div>
        <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text">Phone Number</span></div>
            <input [(ngModel)]="phone" type="tel" name="lastName" class="form-control" placeholder="555-555-5555">
        </div>
        <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text">Amt Due - $</span></div>
            <input [(ngModel)]="totalDue" type="number" name="totalDue" class="form-control" placeholder="000" min="0" max="1000" step="0.01">
        </div>
        <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text">Service</span></div>
            <select [(ngModel)]="service" name="service" class="custom-select">
                <option selected value="">Choose...</option>
                <option value="Bath">Bath</option>
                <option value="Haircut">Haircut</option>
                <option value="Other">Other</option>
                <option value="Haircut-Allison">Haircut - Allison Only</option>
              </select>
        </div>
        <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text">Notes</span></div>
            <textarea [(ngModel)]="dogNotes" type="text" name="dogNotes" class="form-control" placeholder="Notes/Leash Info"></textarea>
        </div>
        <button class="btn btn-clover mb-3 w-100" (click)="addOrUpdateInProgress()">{{ mainButton }}</button>
        <p class="text-danger text-center">{{infoBox}}</p>
    </div>

    <div class="col-md-5 mb-3">
        <h4 class="text-center">Checked In - {{ totalDogs }} Dogs</h4>
        <div class="list-group">
            <div *ngFor="let dog of inProgress">
                <button *ngIf="dog.VISIBLE" (click)="showOptionButtons(dog.UNIQUE_ID)" type="button" class="list-group-item list-group-item-action" [ngClass]="{'text-info':dog.SERVICE === 'Bath','text-success':dog.SERVICE === 'Haircut','text-primary':dog.SERVICE === 'Haircut-Allison'}">
                    <div class="d-flex flex-col">
                        <div class="d-flex w-10 flex-row align-items-center">
                            <i *ngIf="dog.STEP == 0" title="Waiting on Bath" class="fas fa-bath fa-2x"></i>
                            <i *ngIf="dog.STEP == 1" title="Ready for Cut" class="fas fa-cut fa-2x"></i>
                            <i *ngIf="dog.STEP == 2" title="Ready for Payment" class="fas fa-dollar-sign fa-2x"></i>
                            <i *ngIf="dog.STEP == 3" title="Complete" class="fas fa-clipboard-check fa-2x"></i>
                        </div>
                    
                        <div class="d-flex pl-3 w-100 flex-column">
                            <div class="d-flex justify-content-between">
                                <h5 class="mb-1">{{dog.NAME}}</h5>
                                <p class="mb-1">Arrival: {{dog.TIME}}</p>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <p class="mb-1">{{dog.PHONE}}</p>
                                <p class="mb-1">{{dog.SERVICE}}</p>
                            </div>
                            <div class="d-flex w-100 justify-content-between" *ngIf="dog.NOTES != null || (dog.TOTALDUE != undefined && dog.TOTALDUE != null)">                        
                                <p class="mb-0 mt-2">Notes: {{dog.NOTES}}</p>
                                <h5><span *ngIf="dog.TOTALDUE > 0">$</span>{{ dog.TOTALDUE }}</h5>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="showOptions == dog.UNIQUE_ID" class="d-flex w-100 justify-content-between mt-2">
                        <button class="mb-1 btn btn-danger" (click)="postUpdateDog(dog.UNIQUE_ID, 'VISIBLE')">
                            <i class="fas fa-trash"></i>
                        </button>
                <button class="mb-1 btn btn-clover" (click)="editDogInProgress(dog.UNIQUE_ID)">
                            <i class="far fa-edit"></i>
                        </button>
                <button class="mb-1 btn btn-clover-gray" (click)="postUpdateDog(dog.UNIQUE_ID, 'STEP')">Update Status</button>
                <!--<button class="mb-1 btn btn-secondary">Edit</button>-->
                <button class="mb-1 btn btn-clover-gray" (click)="copyDogDetails(dog.UNIQUE_ID)">Copy Details</button>
                <button class="mb-1 btn btn-clover" (click)="showCheckoutSection(dog.UNIQUE_ID)">Check Out</button>
            </div>
            <div *ngIf="showCheckout == dog.UNIQUE_ID" class="w-100 mt-2">
                <div class="input-group">
                    <div class="input-group-prepend"><span class="input-group-text">Total Paid - $</span></div>
                    <input [(ngModel)]="totalPaid" type="number" name="totalPaid" class="form-control" placeholder="000" min="0" max="1000" step="0.01" value="{{dog.TOTALDUE}}">
                    <div class="input-group-prepend"><span class="input-group-text">Payment Type</span></div>
                    <select [(ngModel)]="payType" name="payType" class="custom-select">
                        <option selected value="">Choose...</option>
                        <option value="Cash">Cash</option>
                        <option value="Check">Check</option>
                        <option value="Credit Card">Card</option>                            
                        <option value="Credit Card w Cash Tip">Credit + Cash Tip</option> 
                        <option value="Gift Certificate">Gift Certificate</option> 
                      </select>
                </div>
                <button class="mb-1 btn btn-clover w-100" (click)="postUpdateDog(dog.UNIQUE_ID, 'CHECKOUT')">Confirm</button>
            </div>
            </button>
        </div>
    </div>
</div>
<div class="col-md-4">
    <h4 class="text-center">Completed Dogs</h4>
    <div class="list-group">
        <div *ngFor="let dog of completedDogs">
            <button (click)="showOptionButtons(dog.UNIQUE_ID)" type="button" class="list-group-item list-group-item-action">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{{dog.NAME}}</h5>
                        <p class="mb-1">Arrival: {{dog.TIME}}</p>
                    </div>
                    <div class="d-flex w-100 justify-content-between">
                        <p class="mb-1">{{dog.PHONE}}</p>
                        <p class="mb-1">{{dog.SERVICE}}</p>
                    </div>
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-0 mt-2">Total Due: <span *ngIf="dog.TOTALDUE > 0">$</span>{{ dog.TOTALDUE }}</h5>
                        <h5 class="mb-0 mt-2"><span *ngIf="dog.TOTALPAID > 0">$</span>{{ dog.TOTALPAID }} Paid ({{ dog.PAYMENTTYPE }})</h5>
                    </div>
                    <div *ngIf="showOptions == dog.UNIQUE_ID" class="d-flex w-100 justify-content-between mt-2">
                        <button class="mb-1 btn btn-danger" (click)="copyDogDetails(dog.UNIQUE_ID)">Copy Details</button>
            <button class="mb-1 btn btn-danger" (click)="postUpdateDog(dog.UNIQUE_ID, 'CHECKOUT_UNDO')">Undo Checkout</button>
            <!-- <button class="mb-1 btn btn-danger" (click)="removeDog(dog.UNIQUE_ID)">Remove</button>
            <button class="mb-1 btn btn-secondary">Edit</button> -->

        </div>
        </button>
    </div>
</div>
</div>
</div>